import axios from "axios";

export default {
  state: {
    user: null,
    isLoadingAuthUser: false,
  },
  actions: {
    getAuthUser({commit, state}) {
      state.isLoadingAuthUser = true;
      return axios.get(`/api/v1/me`)
        .then(r => {
          commit("SET_AUTH_USER", r.data.data);
          return r;
        })
        .finally(() => {
          state.isLoadingAuthUser = false;
        });
    },
    logout({commit}){
      axios.get(`/api/v1/logout`)
        .then(() => {
          commit("SET_AUTH_USER", null);
        })
    }
  },
  mutations: {
    SET_AUTH_USER(state, payload) {
      state.user = payload;
    },
  },
  getters: {
    authUser: state => state.user,
  }
};
